import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Paragraph from '../paragraph';
import { APPEARANCES, SIZES } from '../paragraph/constants';
import IconButtonGroup from '../icon-button-group';
import ColorCircle from '../color-circle';

function ColorItem({
  editTooltipLabel = '',
  resetTooltipLabel = '',
  onResetClick = null,
  onEditClick,
  disabled = false,
  title,
  color,
  opacity = 1,
  description = '',
}) {
  const classes = classNames('ws-ui-color-item', {
    'ws-ui-color-item--disabled': disabled,
  });

  const actions = [
    {
      glyph: 'settings',
      appearance: 'light',
      size: 'small',
      label: editTooltipLabel,
      onClick: onEditClick,
    },
  ];

  if (onResetClick) {
    actions.unshift({
      glyph: 'reset',
      appearance: 'light',
      size: 'small',
      label: resetTooltipLabel,
      onClick: onResetClick,
    });
  }

  return (
    <div className={classes} onClick={onEditClick}>
      <ColorCircle color={color} opacity={opacity} size="large" />
      <div className="ws-ui-color-item__container">
        <Paragraph
          appearance={disabled ? APPEARANCES.lowEmphasis : APPEARANCES.highEmphasis}
          isClipped
        >
          {title}
        </Paragraph>
        <div className="ws-ui-color-item__icon-button-group">
          <IconButtonGroup actions={actions} />
        </div>
      </div>
      {description && (
        <div className="ws-ui-color-item__description">
          <Paragraph appearance={APPEARANCES.mediumEmphasis} size={SIZES.small}>
            {description}
          </Paragraph>
        </div>
      )}
    </div>
  );
}

ColorItem.propTypes = {
  onEditClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  opacity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onResetClick: PropTypes.func,
  editTooltipLabel: PropTypes.string,
  resetTooltipLabel: PropTypes.string,
  description: PropTypes.string,
};

export default ColorItem;
